<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before: always;"></div>
<h1 class="P_Heading_1__And__Page_Break" id="auto_bookmark_toc_1"><span>Chapter Four</span></h1>
<p class="P_Normal"> </p>
<p class="P_Normal"> </p>
<p class="P_Normal__And__Left_Indent"><span style=" font-style: italic; font-size: 1.17em;">FUCK TRAFFIC.</span></p>
<p class="P_Normal"><span style=" font-style: italic; font-size: 1.00em;">Fuck traffic and people with more money than sense.</span></p>
<p class="P_Normal">Colby headed west on 119, climbing into the mountains, the stress fading from him as the number of cars started falling away. He turned up the satellite radio and started singing along, but the real peace didn’t come until he’d gone far enough that his phone didn’t have a signal.</p>
<p class="P_Normal">Oh. No texts. No phone calls. No bullshit. Just him, the mountain, and a case of beer.</p>
<p class="P_Normal">Colby drove until the road petered out, and then he pulled over and got the four-wheel drive set and drove some more. He rattled and clattered all the way, bouncing on the seat as he headed up and up until he found just the place.</p>
<p class="P_Normal">He never knew how he found the right place to stop, but he managed to find a good one every weekend, trusting his soul to lead the way. This was why he’d ended up here in this high-dollar town—the mountains. Shit, he’d fallen in love on first sight. The way the aspen leaves shook, the columbines growing out of that last lingering snow.</p>
<p class="P_Normal">The mountains didn’t judge, and they didn’t tolerate fools either. You fucked up, you paid, easy as that.</p>
<p class="P_Normal">One day maybe Gordon would come, see this. Maybe start to understand that he was more than a beer and a tile guy. Maybe start to look at him like he was worth seeing.</p>
<p class="P_Normal">Colby hopped out of the truck and stretched, his back popping like mad. He had his gear, his sleeping bag, cooking grate, his chair, and he’d set up camp here in a bit, but first?</p>
<p class="P_Normal">He grabbed a beer from the cooler and leaned on the wheel well, staring out at the trees. Fuck yeah. He let himself breathe deep, all the shit from the week—good and bad—fading off.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0007.vue?e6a56794